// Dependencies
import React from 'react';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';

import {
  BackImage,
  CarouselPdf,
  CheckLogin,
  CollectionView,
  ContactView,
  DirectoryView,
  FastFactsView,
  FavoriteView,
  Header,
  HeaderSub,
  HomeView,
  MessageCenter,
  MobileWarning,
  Nav,
  NotFoundView,
  NotLoggedInView,
  RetainContentView,
  RetainView,
  Search,
  SubAppView,
  ToolboxView,
  TrainingContentView,
  TrainingView,
  WebsiteSplitter,
} from 'C4';

const loginPages = ['training', 'retain'];
const paths = `(${loginPages.join('|')})`;

const SubRouter = () => (
  <div className="subRouter" id="container">
    <Route path={`/main/${paths}`} render={() => <CheckLogin />} />
    <Route
      path="/main/"
      render={(routerProps) => {
        const { pathname } = routerProps.location;
        if (['/main/', '/main', '/', '/main/landing'].some(route => pathname === route)) {
          return <Header pathname={pathname} />;
        }
        if (pathname.includes('main/training/chapter/')) {
          return null;
        }
        return ((
          <React.Fragment>
            <HeaderSub />
            <Nav secondary />
          </React.Fragment>
        ));
      }}
    />
    <div id="viewContainer" className="viewContainer">
      <BackImage darken={window.location.pathname !== '/main'} />
      <Switch>
        <Route path="/main" exact component={HomeView} />
        <Route path="/main/landing" exact component={HomeView} />
        <Route path="/main/mob" exact component={MobileWarning} />
        <Route path="/main/promote/contact" exact component={ContactView} />
        <Route path="/main/training" exact component={TrainingView} />
        <Route path="/main/ret" exact component={RetainView} />
        <Route
          path="/main/ret/chapter"
          exact
          render={() => <Redirect to="/main/ret" />}
        />
        <Route path="/main/retain" exact component={RetainView} />
        <Route
          path="/main/ret/chapter/:chapterId/:pageId"
          exact
          component={RetainContentView}
        />
        <Route
          path="/main/training/chapter/:chapterId/:pageId"
          render={props => (
            <TrainingContentView key={props.match.params.pageId} {...props} />
          )}
        />
        <Route path="/main/favorites" exact component={FavoriteView} />
        <Route path="/main/promote" exact component={FastFactsView} />
        <Route path="/main/sell" exact component={ToolboxView} />
        <Route path="/main/subApp" exact component={SubAppView} />
        <Route path="/main/directory" exact component={DirectoryView} />
        <Route path="/main/messages" exact component={MessageCenter} />
        <Route path="/main/landing/messages" exact component={MessageCenter} />
        <Route path="/main/sell/videos/:videoId?" component={CollectionView} />
        <Route path="/main/sell/images/:imageId?" component={CollectionView} />
        <Route path="/main/sell/image-library/:imageId?" component={CollectionView} />
        <Route path="/main/promote/brochures/" component={CollectionView} />
        <Route
          path="/main/sell/videoLibrary/:videoId?"
          component={CollectionView}
        />
        <Route
          path="/main/sell/imageLibrary/:imageId?"
          component={CollectionView}
        />
        <Route path="/main/promote/itineraries" component={CollectionView} />
        <Route
          path="/main/promote/travel-itineraries"
          component={CollectionView}
        />
        <Route
          path="/main/promote/sample-itineraries"
          component={CollectionView}
        />
        <Route path="/main/sell/e-guides" component={CollectionView} />
        <Route path="/main/sell/sales-flyers" component={CollectionView} />
        <Route path="/main/sell/brochures/:item?" component={CollectionView} />
        <Route path="/main/search" component={Search} />
        <Route path="/main/off" component={NotLoggedInView} />
        <Route
          path="/main/splitter/:itemId/:type"
          component={WebsiteSplitter}
        />
        <Route component={NotFoundView} />
      </Switch>
    </div>
    {/* <Footer /> */}
  </div>
);

export default withRouter(SubRouter);
